<div class="flex h-full flex-col">
  <div class="header relative p-3">
    <h3 class="title text-center text-lg">Share with</h3>
    <button
      type="button"
      class="close absolute top-[50%] right-3 -translate-y-[50%]"
      (click)="onClose()">
      <fa-icon class="mr-2" [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <div class="conten flex-1 space-y-3 overflow-y-auto p-3 lg:py-10">
    <div class="flex items-center justify-center gap-3">
      <div class="text-center">
        <button
          type="button"
          class="flex items-center rounded-full border p-2 px-4 shadow-md hover:bg-gray-100"
          (click)="onShareByFacebook()">
          <fa-icon class="mr-2 text-2xl" [icon]="faFacebook"></fa-icon>
          <span>Facebook</span>
        </button>
      </div>
      <span>Atau</span>
      <div class="text-center">
        <button
          type="button"
          class="flex items-center rounded-full border p-2 px-4 shadow-md hover:bg-gray-100"
          (click)="onShareByLink()">
          <fa-icon class="mr-2 text-2xl" [icon]="faLink"></fa-icon>
          <span>Copy Link</span>
        </button>
      </div>
    </div>
  </div>
</div>
